/* ZIIV custom sections — reveal-on-scroll.
   Content is visible by default; hiding is gated on the .zv-js class added
   here. Reveal uses a synchronous scroll sweep plus a timer fallback —
   no rAF or IntersectionObserver, since neither runs when the renderer
   treats the document as hidden (embedded previews, background tabs),
   which would leave sections invisible. */
(function () {
  if (window.__zvRevealInit) return;
  window.__zvRevealInit = true;

  // Hidden documents (background tabs, embedded previews) don't run rAF or
  // paint transitions — leave content fully visible there instead of animating.
  if (document.visibilityState === 'hidden') return;
  document.documentElement.classList.add('zv-js');

  var els = [];

  function sweep() {
    els = els.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight - 40 && r.bottom > 0) {
        el.classList.add('zv-in');
        return false;
      }
      return true;
    });
  }

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function collect() {
    if (!reduce) { markDrift(); driftSweep(); }
    var found = document.querySelectorAll('.zv-reveal:not(.zv-in)');
    for (var i = 0; i < found.length; i++) {
      if (els.indexOf(found[i]) === -1) els.push(found[i]);
    }
    sweep();
  }

  /* Headings and body copy are handled purely in CSS — every one of them is
     already inside a .zv-reveal container (.zv-section__head wraps the eyebrow,
     the h2 and the lead), so marking them individually would mark nothing.
     The stylesheet staggers those children off the parent's .zv-in instead. */

  /* Cards drift a few pixels as they cross the viewport, so scrolling moves
     them rather than just fading them in once. One passive listener, coalesced
     into a frame, writing a custom property — no layout reads per card beyond
     the rect it already needs. */
  var drifters = [];
  var driftQueued = false;

  function markDrift() {
    var found = document.querySelectorAll('.zv-stat, .zv-step, .zv-case, .zv-insta__tile');
    drifters = [];
    for (var i = 0; i < found.length; i++) {
      found[i].classList.add('zv-drift');
      drifters.push(found[i]);
    }
  }

  function driftSweep() {
    driftQueued = false;
    var vh = window.innerHeight;
    for (var i = 0; i < drifters.length; i++) {
      var el = drifters[i];
      var r = el.getBoundingClientRect();
      if (r.bottom < -120 || r.top > vh + 120) continue;
      // +1 when the card is entering from the bottom, -1 as it leaves the top
      var mid = r.top + r.height / 2;
      var p = (vh / 2 - mid) / (vh / 2 + r.height / 2);
      if (p > 1) p = 1; else if (p < -1) p = -1;
      el.style.setProperty('--zv-drift', (p * 7).toFixed(1) + 'px');
    }
  }

  function onScroll() {
    sweep();
    if (!driftQueued) {
      driftQueued = true;
      if (window.requestAnimationFrame) requestAnimationFrame(driftSweep);
      else driftSweep();
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setInterval(function () { if (els.length) sweep(); }, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
  // Re-collect when the Shopify theme editor re-renders a section
  document.addEventListener('shopify:section:load', collect);
})();
